// src/Pages/ClientMasterWrapper.jsx
import { useEffect, useState } from "react";
import ClientMaster from "./ClientMaster";

export default function ClientMasterWrapper() {
    const [receivedProps, setReceivedProps] = useState(null);

    useEffect(() => {
        function handleMessage(event) {
            try {
                const data = JSON.parse(event.data);
                if (data?.fromReactNative) {
                    setReceivedProps({
                        loggedInUser: data.loggedInUser,
                        companyData: data.companyData,
                        mode: "add", // force mode to 'add'
                    });
                }
            } catch (err) {
                console.error("Failed to parse message:", err);
            }
        }

        window.addEventListener("message", handleMessage);
        document.addEventListener("message", handleMessage); // required for Android RN

        return () => {
            window.removeEventListener("message", handleMessage);
            document.removeEventListener("message", handleMessage);
        };
    }, []);

    return receivedProps ? (
        <ClientMaster {...receivedProps} />
    ) : (
        <p>Waiting for data from React Native...</p>
    );
}